import {AppLanguage} from 'platform/locale';

import {getSafely} from 'shared/web';

import {RelatedAction, Translation} from '../api/digitalCertificateApi';
import {isCebiaWorkspace} from './isCebiaWorkspace';

export function getExtraFlagTexts({
  relatedAction,
  auditValueKey,
  language,
}: {
  relatedAction: RelatedAction;
  auditValueKey: string;
  language: AppLanguage;
}) {
  if (!isCebiaWorkspace()) {
    return [];
  }

  if (auditValueKey !== 'FLAWLESS') {
    return [];
  }

  const flagTextsFromRelatedAction = relatedAction?.values?.find(
    (relatedActionValue) => relatedActionValue.value === auditValueKey
  );

  if (flagTextsFromRelatedAction) {
    const flagText = getSafely(flagTextsFromRelatedAction?.label, language as keyof Translation);

    if (flagText) {
      return [{flagText, variant: 'ready'} as const];
    }
  }

  return [];
}
